import '../../../../../node_modules/@lit/reactive-element/reactive-element.js';
import '../../../../../node_modules/lit-html/lit-html.js';
import '../../../../../node_modules/lit-element/lit-element.js';
import { css as i } from '../../../../../node_modules/@lit/reactive-element/css-tag.js';

var css_248z = i`:host([isGroupsite]) .header{margin-bottom:24px;min-height:64px;padding:0}:host([isGroupsite]) .content .inner{padding:0}`;

export { css_248z as default };
